<template>
  <el-row class="container">
    <div class="navbar clearfix">
      <div class="logo pull-left">
        <span style="cursor:pointer;" class="title" @click="() => { this.$router.push('/dashboard') }">正汇通溜溜测评管理系统</span>
      </div>



      <div class="navbar-custom-menu pull-right">
        <div class="nav navbar-nav">
          <!-- 未读消息列表-->
          <div class="nav-item messages-menu">
            <a href="#" class="link-black" title="我的消息">
              <i class="fa fa-envelope-o"></i>
            </a>
          </div>
          <!-- 未读通知列表 -->
          <div class="nav-item notifications-menu">
            <a href="#" class="link-black" title="我的通知">
              <i class="fa fa-bell-o"></i>
            </a>
          </div>

          <!--用户头像-->
          <el-dropdown trigger="hover" class="nav-item user user-menu">
            <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown">
              <img v-if="avatar" :src="avatar" class="avatar"/>
              <img v-else src="@/assets/images/avatar.png" class="avatar"/>
              <div class="name-wrap">
                <div class="uname">{{ user.trueName }}</div>
                <div class="cname">{{ company.name }}</div>
              </div>
            </a>
            <el-dropdown-menu class="dropdown-menu" slot="dropdown">
              <el-dropdown-item divided><i class="fa fa-comment-o"></i>我的消息</el-dropdown-item>
              <el-dropdown-item @click.native="viaSetting"><i class="fa fa-user-circle"></i>修改头像</el-dropdown-item>
              <el-dropdown-item @click.native="settings"><i class="fa fa-cogs"></i>修改资料</el-dropdown-item>
              <el-dropdown-item @click.native="changePwd"><i class="fa fa-key"></i>修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout"><i class="fa fa-sign-out"></i>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!--
          <div class="nav-item">
						<a href="#" data-toggle="control-sidebar" title="设置"><i class="fa fa-gears"></i></a>
					</div>
					-->
        </div>
      </div>
    </div>

    <!-- 修改头像-->
    <edit-avatar :visible="dialogVisible.cropper" @done="finishInfo"></edit-avatar>

    <!-- 修改资料-->
    <edit-info :visible="dialogVisible.setter" @done="finishInfo"></edit-info>

    <!-- 修改密码-->
    <edit-pwd :visible="dialogVisible.password" @done="finishInfo"></edit-pwd>
  </el-row>
</template>

<script>
import { isExternal } from '@/utils/index'
import EditAvatar from '@/views/dashboard/EditAvatar'
import EditInfo from '@/views/dashboard/EditInfo'
import EditPwd from '@/views/dashboard/EditPwd'
import { mapGetters } from 'vuex'
import { resetRouter } from '@/router'

export default {
  components: {
    EditAvatar,
    EditInfo,
    EditPwd
  },
  data() {
    return {
      collapsed: false,
      dialogVisible: {
        setter: false,
        cropper: false,
        password: false
      },
      active: ''
    }
  },
  computed: {
    ...mapGetters(['user', 'company', 'routes', 'avatar']),
    menus() {
      return this.routes.filter(x => x.meta)
    }
  },
  created() {
    this.initCurrentRoutes()
  },
  methods: {
    initCurrentRoutes() {
      this.active = this.menus[0] ? this.menus[0].name : ''

      // 通过当前路径找到二级菜单对应项，存到store，用来渲染左侧菜单
      const { path } = this.$route
      let route = this.menus.find(item => item.path === '/' + path.split('/')[1])

      if (!route) {
        // 如果找不到这个路由，说明是首页
        // route = this.routes.find(item => item.path === '/')
        route = this.menus[0] // 取第一个路由做为默认路由
      }
      this.$store.commit('user/SET_CURRENT_ROUTES', route)
    },
    toSwitch() {
      this.$router.push(`/join/company`)
    },
    resolvePath(item) {
      if (isExternal(item.path)) {
        // 如果是个完成的url直接返回
        return item.path
      }

      if (item.path === '/') {
        // 如果是首页，就返回重定向路由
        const path = item.redirect
        return path
      }

      let path = '' // 如果有子项，默认跳转第一个子项路由
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        if (isExternal(item.path)) {
          // 如果path是个外部链接（不建议），直接返回链接，存在个问题：如果是外部链接点击跳转后当前页内容还是上一个路由内容
          path = item.path
          return
        }

        if (parent) {
          // 第一次需要父项路由拼接，所以只是第一个传parent
          path += parent.path + '/' + item.path
        } else {
          path += '/' + item.path
        }
        // 如果还有子项，继续递归
        if (item.children) {
          getDefaultPath(item.children[0])
        }
      }

      if (item.children) {
        getDefaultPath(item.children[0], item)
        return path
      }

      return item.path
    },
    changeNav(nav) {
      // 把选中路由的子路由保存store
      const route = this.menus.find(item => item.path === nav.path)
      this.$store.commit('user/SET_CURRENT_ROUTES', route)
      this.active = nav.name
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.replace(`/login`)
      resetRouter()
    },
    settings() {
      this.dialogVisible.setter = true
    },
    viaSetting() {
      this.dialogVisible.cropper = true
    },
    changePwd() {
      this.dialogVisible.password = true
    },
    finishInfo() {
      this.dialogVisible.setter = false
      this.dialogVisible.password = false
      this.dialogVisible.cropper = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dropdown-menu__item .fa {
  margin-right: 5px;
}

.user-menu {
  .dropdown-toggle {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .avatar {
      border-radius: 50px;
      width: 40px;
      height: 40px;
      margin: 0 10px;
    }

    .name-wrap {
      flex: 1;
      line-height: initial;
      text-align: left;

      .uname {
        font-weight: 700;
        font-size: 14px;
      }

      .cname {
        font-size: 11px;
      }

    }
  }
}
</style>
